import { useAuth } from "../../../../context/auth";
import { useDrawer } from "../../../../hooks/useDrawer";

export const useUser = () => {
  const { user, logout } = useAuth();
  const { drawerOpen, drawerShow, toggleDrawerOpen } = useDrawer();

  
  const redirectToLoginPage = () => {
    window.location.href = ("/dovemed-sso/?next=" + window.location.href);
  }
  
  const redirectToCoreProfile = () => {
    window.location.href = "/accounts/profile/physician/";
  }

  return {
    redirectToLoginPage,
    drawerOpen,
    drawerShow,
    toggleDrawerOpen,
    user,
    logout,
    redirectToCoreProfile
  }
}